// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.CreateRenterPaymentMethodWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod } from '@zg-rentals/ts-rent-payment-client';

import type {
  CreateRenterPaymentMethodWebApiRequestDto,
  CreateRenterPaymentMethodWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export interface CreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod_Args {
  postData: CreateRenterPaymentMethodWebApiRequestDto;
}

export type CreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod_Options = UseMutationOptions<
  CreateRenterPaymentMethodWebApiResponseDto,
  unknown,
  CreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod_Args
>;

/**
 * create renter payment method
 */
export const useCreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod = ({
  httpClient,
  ...options
}: Omit<CreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod_Args) =>
      CreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod(args.postData, httpClient),
  });
};
